export enum SponsorshipTier {
    Bronze = 0,
    Silver = 1,
    Gold = 2
}

export interface ISponsorshipInfo {
    id?: number;
    elementName: string;
    atomicNumber: number;
    conferenceId: number;
    title: string;
    imageUrl: string;
    linkUrl: string;
    tier: SponsorshipTier;
    contactName: string;
    contactEmail: string;
    contactAddress: string;
    contactPhone: string;
    payby: "paypal" | "check";
    paid: boolean;
    cost: number;
    memberId?: number; // only populated if logged in member is sponsoring on behalf of their institution
}